/* eslint-disable import/no-cycle */
import { all, takeLatest, call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';
import {
  getRenotarizationLogsSuccess,
  getRenotarizationHistorySuccess,
  renotarizationLogsFailure,
} from './actions';
import { refreshTokenRequest } from '../auth/actions';
import { store } from '../../index';

export function* getRenotarizationLogs({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const {
      limit = 10,
      page = 1,
      clientId,
      yourNumber,
      restampResult,
      dateStart,
      dateEnd,
      onSuccess,
    } = payload;

    const response = yield call(
      (url) =>
        api.get(url, {
          params: {
            client_id: clientId,
            your_number: yourNumber,
            restamp_result: restampResult,
            date_start: dateStart,
            date_end: dateEnd,
            limit,
            page,
          },
        }),
      '/signature-data/v1/renotarization-log'
    );

    yield put(getRenotarizationLogsSuccess(response.data));
    if (onSuccess) onSuccess();
  } catch (err) {
    if (err.response.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(renotarizationLogsFailure());
      toast.error('Falha ao listar registros de renotarização');
    }
  }
}

export function* getRenotarizationHistory({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const { yourNumber, clientId } = payload;
    const response = yield call(
      api.get,
      '/signature-data/v1/renotarization-log',
      {
        params: { your_number: yourNumber, client_id: clientId },
      }
    );
    yield put(getRenotarizationHistorySuccess(response.data.content));
  } catch (err) {
    if (err.response.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(renotarizationLogsFailure());
      toast.error('Falha ao carregar histórico de processamento');
    }
  }
}

export default all([
  takeLatest('@renotarizationLogs/GET_REQUEST', getRenotarizationLogs),
  takeLatest(
    '@renotarizationLogs/GET_HISTORY_REQUEST',
    getRenotarizationHistory
  ),
]);
